import de from "./de";
import en from "./en";
import tr from "./tr";
import ru from "./ru";
import pl from "./pl";
import hr from "./hr";
import it from "./it";
import ar from "./ar";

export const MESSAGES = { de, en, tr, ru, pl, hr, it, ar };
